<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Squadre</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="addSquadra" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Squadra</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      dense
      height="45vh"
      :items="squadre.filter((e) => e.validita == 1)"
      :headers="headers_squadre"
      show-expand
      single-expand
      :expanded.sync="expanded"
      item-key="idx"
    >
      <template v-slot:[`item.des`]="{ item }">
        <v-text-field dense v-model="item.des"></v-text-field>
      </template>
      <template v-slot:[`item.aggPersone`]="{ item, index }">
        <v-btn @click="addPersone(item, index)" small
          ><v-icon color="primary">mdi-plus</v-icon></v-btn
        >
      </template>
      <template v-slot:[`item.delete`]="{ item, index }">
        <v-btn @click="deleteSquadra(item, index)" small
          ><v-icon color="error">mdi-close</v-icon></v-btn
        >
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          class="pa-0"
          style="background-color: white"
        >
          <v-data-table
            dense
            :items="item.persone.filter((e) => e.validita == 1)"
            :headers="headers_persone"
          >
            <template v-slot:[`item.caposquadra`]="{ item }">
              <v-checkbox
                dense
                :true-value="1"
                :false-value="0"
                v-model="item.caposquadra"
              ></v-checkbox>
            </template>
            <template v-slot:[`item.delete`]="{ item, index }">
              <v-btn @click="deletePersona(item, index)" small
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_persone" width="40vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Aggiungi Persone</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="confirmAdd" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Persone</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_persone = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-select
            multiple
            :items="persone"
            v-model="personeSelezionati"
            item-text="nominativo"
            return-object
          ></v-select>
        </v-card-text>
        <SnackbarQV ref="SnackbarQV" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Squadre",
  components: {
    SnackbarQV,
  },

  props: ["reparto"],

  data() {
    return {
      overlay: false,
      next_tmp: 0,
      expanded: [],
      squadraAttuale: {},
      dialog_persone: false,
      squadre: [],
      persone: [],
      personeSelezionati: [],
      headers_squadre: [
        { text: "Nome", value: "des" },
        { text: "Aggiungi Persone", value: "aggPersone" },
        { text: "Rimuovi", value: "delete" },
      ],
      headers_persone: [
        { text: "Nome", value: "nome" },
        { text: "Cognome", value: "cognome" },
        { text: "Caposquadra", value: "caposquadra" },
        { text: "Rimuovi", value: "delete" },
      ],
    };
  },

  methods: {
    confirmAdd() {
      for (const p of this.personeSelezionati) {
        this.squadraAttuale.persone.push({
          id_squadra_persona: -1,
          id_squadra: this.squadraAttuale.id_squadra,
          id_squadra_tmp: this.squadraAttuale.id_tmp,
          id_personale: p.id_personale,
          nome: p.nome,
          cognome: p.cognome,
          validita: 1,
        });
      }
      this.personeSelezionati = [];
      this.dialog_persone = false;
    },
    deletePersona(item, index) {
      console.log(index);
      item.validita = 0;
    },
    async getUtenti() {
      let getUtenteList = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", getUtenteList).then((res) => {
        if (res.status === 200) {
          this.persone = res.data;
        }
      });
    },
    addPersone(item, index) {
      console.log(index);
      this.squadraAttuale = item;
      this.personeSelezionati = [];
      this.dialog_persone = true;
    },
    async getSquadre() {
      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getsquadre",
          id_reparto: this.reparto.id_azienda_sede_reparto,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.squadre = res.data.result.squadre;
            for (let i = 0; i < this.squadre.length; i++) {
              this.squadre[i].idx = i;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    addSquadra() {
      this.squadre.push({
        id_squadra: -1,
        id_tmp: this.next_tmp,
        des: "Nuova Squadra",
        id_reparto: this.reparto.id_azienda_sede_reparto,
        validita: 1,
        persone: [],
        idx: this.squadre.length,
      });
      this.next_tmp++;
    },
    deleteSquadra(item, index) {
      if (item.id_reparto_squadra == -1) {
        this.squadre.splice(index, 1);
      } else {
        item.validita = 0;
      }
    },
    async saveSquadre() {
      this.overlay = true;
      let request = {
        controller: "magazzino",
        method: "PUT",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "setsquadre",
          squadre: this.squadre,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Squadre salvate con successo"
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
      this.overlay = false;
    },
  },
  async mounted() {
    this.overlay = true;
    await this.getUtenti();
    await this.getSquadre();
    this.overlay = false;
  },
};
</script>

<style>
</style>